import { heroChips } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-[92vh] w-full items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20artistic%20background%20with%20warm%20rose%20red%20and%20amber%20gold%20gradient%20tones%2C%20soft%20bokeh%20light%20spots%2C%20subtle%20film%20grain%20texture%2C%20elegant%20dramatic%20mood%2C%20dark%20rich%20contrast%20suitable%20for%20white%20text%20overlay%2C%20minimal%20modern%20editorial%20composition&width=1920&height=1080&seq=hanjutv-hero-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85"></div>

      <div className="relative z-10 w-full px-4 pb-16 pt-28 md:px-8 md:pb-24 md:pt-36">
        <div className="mx-auto max-w-4xl text-center">
          <span className="animate-rise inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur md:text-sm">
            <i className="ri-play-circle-line text-base text-accent-300"></i>
            韩剧TV · 下载安装与离线观看指南
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            韩剧TV 下载安装
            <span className="block text-accent-300">缓存视频与离线观看指南</span>
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-50/85 md:mt-6 md:text-lg">
            这里整理了韩剧TV 从下载安装、缓存视频到离线观看的完整流程，并分别说明安卓版下载、苹果版下载与下载到手机的注意事项，帮你快速找到需要的那一步。
          </p>

          <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
            <a
              href="#install"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:text-base"
            >
              <i className="ri-download-2-line text-lg"></i>
              <span className="whitespace-nowrap">查看下载安装步骤</span>
            </a>
            <a
              href="#cache"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 md:text-base"
            >
              <i className="ri-download-cloud-2-line text-lg"></i>
              <span className="whitespace-nowrap">学习缓存视频</span>
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3 md:mt-12">
            {heroChips.map((chip) => (
              <span
                key={chip.text}
                className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-foreground-950/30 px-4 py-2 text-xs font-medium text-background-50/90 backdrop-blur md:text-sm"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className={`${chip.icon} text-base text-accent-300`}></i>
                </span>
                {chip.text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}